import React, { Component } from 'react'
import { Layer, Box, Text } from 'grommet';
/*import ButtonBlue from '../Utils/buttonBlue';*/
import { withRouter } from "react-router-dom";
/*import { logout } from '../Utils/Utility';*/



class ModalErrorDispute extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {

        return (
            <Layer
                onClickOutside={this.props.closeModal}
                onEsc={this.props.closeModal}
                flush={true}
                animate={true}
                style={{ width: '40%', 'z-index': '9999' }}
            >
                <Box  background='white' pad='medium'>
                    <Box direction="row">
                        <Box>
                            <i className='icon-close' style={{ textAlign: 'right', fontSize: '15px', color: '#000000', float: 'right', cursor: 'pointer' }} onClick={this.props.closeModal}></i>
                            <h3>Attenzione</h3>
                            <Text style={{ textAlign: 'left'}}>Non è possibile procedere con l'evasione. Se non evadi con altri mezzi è necessario allegare della documentazione o inserire un commento.</Text>
                        </Box>
                     </Box>
                </Box>
            </Layer >
        )
    }
}


class ModalErrorSummaryDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {

        return (
            <Layer
                onClickOutside={this.props.closeModal}
                onEsc={this.props.closeModal}
                flush={true}
                animate={true}
                style={{ width: '30%', 'z-index': '9999' }}
            >
                <Box  background='white' align="center" pad='medium'>
                    <Box direction="row">
                        <Box>
                            <i className='icon-close' style={{ textAlign: 'right', fontSize: '15px', color: '#000000', float: 'right', cursor: 'pointer' }} onClick={this.props.closeModal}></i>
                            <h3>Attenzione</h3>
                            <Text>Per visualizzare il dettaglio selezionare prima un punto vendita</Text>
                        </Box>
                     </Box>
                </Box>
            </Layer >
        )
    }
}



class ModalErrorExcel extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {

        return (
            <Layer
                onClickOutside={this.props.closeModal}
                onEsc={this.props.closeModal}
                flush={true}
                animate={true}
                style={{ width: '35%', 'z-index': '9999' }}
            >
                <Box  background='white' align="center" pad='medium'>
                    <Box direction="row">
                        <Box>
                            <i className='icon-close' style={{ textAlign: 'right', fontSize: '15px', color: '#000000', float: 'right', cursor: 'pointer' }} onClick={this.props.closeModal}></i>
                            <h3>Attenzione</h3>
                            <Text>I dati eccedono la dimensione esportabile (5000). È necessario raffinare la ricerca.</Text>
                        </Box>
                     </Box>
                </Box>
            </Layer >
        )
    }
}






class ModalError extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <Box>
                { this.props.type === "dispute" ? <ModalErrorDispute closeModal={this.props.closeModal}/>
                    : this.props.type === "details" ? <ModalErrorSummaryDetails closeModal={this.props.closeModal}/>
                        : this.props.type === "excel" ? <ModalErrorExcel closeModal={this.props.closeModal}/> 
                            : ""}
            </Box>
        )
    }
}
export default ModalError = withRouter(ModalError);
